import { StyleOfText } from "../../textStyle";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { TournamentDetailsPopup } from "./ranking/tournamentPopup";
import {
  TournamentParticipation,
  TournamentRanking,
} from "./Interfaces_Tournament";
import { onOptionButtonDownRedirectHome } from "../../functions/Functions_General";

export class Tournament {
  private parent: PIXI.Container;
  private rankingContainer: PIXI.Container;
  private activeGameData: CommonData;
  private icon_time: PIXI.Sprite;
  private icon_rank: PIXI.Sprite;
  private icon_points: PIXI.Sprite;
  private ui_ranking: PIXI.Sprite;
  private ui_timeleft: PIXI.Sprite;
  private ui_points: PIXI.Sprite;
  private display_timeLeft: PIXI.Text;
  private display_ranking: PIXI.Text;
  private display_points: PIXI.Text;

  private data_timeLeft: string;
  private data_ranking: number;
  private data_totalRanking: number;
  private data_points: number;

  private text_style: PIXI.TextStyle;
  private gameFont: StyleOfText;
  private displayTimer: boolean;

  private updateInterval: number;

  //---popper

  private rankingList: TournamentDetailsPopup;
  private isActive: boolean;

  private ticker_D: number;
  private autoUpdateTicker: PIXI.ticker.Ticker;

  // private msgBox:PopupMessageBox;
  // private maxPerPage:number;
  // private text

  private btn_spriteTournament: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("icon_rank.png")
  );

  private btn_spriteHome: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("icon_Home.png")
  );
  private btn_redirectToHomepage: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("btnTournament.png")
  );
  private btn_openCloseTournament: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("btnTournament.png")
  ); //btnGamble_M

  //player data
  // private participated:boolean=false;
  // private activeSession:boolean=false;
  // private allowedToRegister:boolean=false;
  // private playerBalanceServerValue:number=0;

  constructor(parent: PIXI.Container, gameData: CommonData) {
    this.activeGameData = gameData;
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.rankingContainer = new PIXI.Container();
    this.parent.addChild(this.rankingContainer);

    this.displayTimer = false;
    this.ui_points = new PIXI.Sprite(
      PIXI.Texture.fromFrame("tournamentClickable.png")
    );
    this.ui_points.anchor.set(0.5);
    this.parent.addChild(this.ui_points);

    this.ui_ranking = new PIXI.Sprite(
      PIXI.Texture.fromFrame("tournamentClickable.png")
    );
    this.ui_ranking.anchor.set(0.5);
    this.parent.addChild(this.ui_ranking);

    //----
    this.makeClickable(true);
    this.ui_ranking.on("pointertap", this.goToRankingPage);
    this.ui_points.on("pointertap", this.goToRankingPage);
    //--
    this.ui_timeleft = new PIXI.Sprite(
      PIXI.Texture.fromFrame("tournamentClickable.png")
    );
    this.ui_timeleft.anchor.set(0.5);
    if (this.displayTimer) {
      this.parent.addChild(this.ui_timeleft);
    }

    this.gameFont = new StyleOfText();
    this.text_style = new PIXI.TextStyle({
      fontFamily: this.gameFont.gameFont,
      dropShadow: true,
      dropShadowColor: "#d44a2d",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      fill: ["#ffffff"],
      fontWeight: "bold",
      fontSize: 35,
      align: "center",
      wordWrap: false,
    });

    this.data_points = 0;
    this.data_ranking = 0;
    this.data_timeLeft = "Time Left";
    this.data_totalRanking = 0;
    // default text;
    // console.log(this.activeGameData.tournamentText);
    this.display_points = new PIXI.Text(
      this.data_points.toFixed(2),
      this.text_style
    );
    this.display_ranking = new PIXI.Text(
      this.data_ranking + "/" + this.data_totalRanking,
      this.text_style
    );
    this.display_timeLeft = new PIXI.Text(
      this.data_timeLeft + "",
      this.text_style
    );

    this.display_points.anchor.set(0, 0.5);
    this.display_ranking.anchor.set(0, 0.5);
    this.display_timeLeft.anchor.set(0, 0.5);

    this.ui_points.addChild(this.display_points);
    this.ui_ranking.addChild(this.display_ranking);
    this.ui_timeleft.addChild(this.display_timeLeft);

    this.icon_points = new PIXI.Sprite(
      PIXI.Texture.fromFrame("icon_points.png")
    );
    this.icon_rank = new PIXI.Sprite(PIXI.Texture.fromFrame("icon_rank.png"));
    this.icon_time = new PIXI.Sprite(PIXI.Texture.fromFrame("icon_clock.png"));

    this.icon_points.anchor.set(0.5);
    this.icon_rank.anchor.set(0.5);
    this.icon_time.anchor.set(0.5);

    this.ui_points.addChild(this.icon_points);
    this.ui_ranking.addChild(this.icon_rank);
    this.ui_timeleft.addChild(this.icon_time);
    //default 0this.bg.width-300
    this.data_points = 0;
    this.data_totalRanking = 0;
    this.data_ranking = 0;
    this.isActive = true; //default true

    this.requeServerForScore();
    this.rankingList = new TournamentDetailsPopup(
      this.rankingContainer,
      this.activeGameData
    );
    //---
    //enable the server auto update
    // this.EnableAutoServerRequest();
    // this.maxPerPage=this.rankingList.getMaxRankPerPage();
    //-create buttons

    //  this.parent.addChild(this.btn_redirectToHomepage);
    this.parent.addChild(this.btn_openCloseTournament);
    this.btn_spriteTournament.y = 8;
    this.btn_spriteHome.y = -5;
    this.btn_openCloseTournament.addChild(this.btn_spriteTournament);
    this.btn_spriteTournament.anchor.set(0.5);
    this.btn_spriteTournament.scale.set(1.75);

    //  this.btn_redirectToHomepage.addChild(this.btn_spriteHome);
    this.btn_spriteHome.anchor.set(0.5);
    this.btn_spriteHome.scale.set(1.4);

    this.btn_redirectToHomepage.anchor.set(0.5);
    this.btn_openCloseTournament.anchor.set(0.5);

    this.btn_redirectToHomepage.on(
      "pointertap",
      onOptionButtonDownRedirectHome
    );
    this.btn_openCloseTournament.on("pointertap", this.goToRankingPage);

    this.defaultPlacing();
    this.setModeLandscape(true); //default mode landscape

    this.updateInterval = 10000;
    this.autoUpdate();

    //--remove this
    // this.click()
    // activeGameData.tournamentmode.openRanking();
    // this.openRanking();

    // this.createMsgBox();//will display the message on tournament
  }

  // private createMsgBox=():void=>
  // {
  //     this.msgBox= new PopupMessageBox(1,this.activeGameData.size);
  //     this.msgBox.setBodyText(this.activeGameData.tournamentText.WELCOMEHEAD+"\n"+this.activeGameData.tournamentText.WELCOMEMSG);
  //     this.msgBox.setHeadText('');
  //     this.msgBox.setLabel(0,this.activeGameData.gameTextGeneral.continue);
  //     this.msgBox.setButtons(0,function(){})
  //     this.msgBox.setChildOf(this.parent);

  //     this.msgBox.setMessageBoxVisibile(true);

  // }

  private defaultPlacing = (): void => {
    let labelWidth = this.ui_points.width;
    let gameWidth = this.activeGameData.size[0];
    this.ui_timeleft.x = gameWidth / 2 / 2;
    this.ui_timeleft.y = this.ui_points.height / 2 + 10;
    this.ui_ranking.x = gameWidth / 2;
    this.ui_ranking.y = this.ui_timeleft.y;
    this.ui_points.x = this.ui_timeleft.x * 3;
    this.ui_points.y = this.ui_timeleft.y;

    if (this.displayTimer == false) {
      this.ui_ranking.x = gameWidth / 2 - labelWidth / 2 - 50;
      this.ui_points.x = gameWidth / 2 + labelWidth / 2 + 50;
    }
    this.icon_points.x = -this.ui_points.width / 2 + this.icon_points.width;
    this.icon_rank.x = -this.ui_points.width / 2 + this.icon_rank.width;
    this.icon_time.x = -this.ui_points.width / 2 + this.icon_time.width;

    this.display_points.x = -this.display_points.width / 2;
    this.display_ranking.x = -this.display_ranking.width / 2;
    this.display_timeLeft.x = -this.display_timeLeft.width / 2;

    if (this.activeGameData.gameType == this.activeGameData.gameTypesList[1]) {
      //if its dice game
      this.ui_ranking.x = 600; //(gameWidth/2);
      this.ui_points.x = this.activeGameData.size[0] - 600;
    }
    this.btn_redirectToHomepage.scale.set(0.7);
    this.btn_openCloseTournament.scale.set(0.7);
    this.btn_redirectToHomepage.position.set(80, 60 + 150);
    this.btn_openCloseTournament.position.set(80, 60 + 150); //(this.btn_redirectToHomepage.x,this.btn_redirectToHomepage.y+150);
    if (this.activeGameData.isTableGame) {
      this.btn_openCloseTournament.position.set(50, 620); //.set(this.btn_redirectToHomepage.x,this.btn_redirectToHomepage.y+150);
    }
  };

  public setPoints = (newVal: number): void => {
    this.data_points = newVal;

    this.display_points.text = this.data_points.toFixed(2);
    this.display_points.x = -this.display_points.width / 2;
  };

  public setRanking = (userPos: number, total: number): void => {
    this.data_totalRanking = total;
    this.data_ranking = userPos;

    this.display_ranking.text =
      this.data_ranking + "/" + this.data_totalRanking;
    this.display_ranking.x = -this.display_ranking.width / 2;
    // this.
  };

  // public updateRankAfterRebuy=(userPos:number):void=>
  // {
  //     //---update the player bar;
  //     this.data_ranking=userPos;
  //     this.display_ranking.text=this.data_ranking+'/'+this.data_totalRanking;
  //     this.display_ranking.x=-this.display_ranking.width/2;

  //     this.rankingList.setRankOnlyAfterRebuy( this.data_ranking, this.data_totalRanking);
  // }
  public getTotalEntries = (): number => {
    return this.data_totalRanking;
  };

  private autoUpdate = (): void => {
    // let requestServerFn=this.requestServer;

    // setInterval(function(){
    //     // console.log(functionRequestServer);
    //     requestServerFn();

    // }.bind(requestServerFn), this.updateInterval);

    this.ticker_D = Date.now();
    this.autoUpdateTicker = new PIXI.ticker.Ticker();
    this.autoUpdateTicker.stop();
    this.autoUpdateTicker.add(() => {
      if (Date.now() - this.ticker_D > this.updateInterval) {
        //Check TimeCheckEvery10Sec
        this.requestServer();
        this.ticker_D = Date.now();

        //--autoOpen the
        if (
          this.rankingList.getIsTournamentEnded() &&
          this.activeGameData.balance.getValue() == 0 &&
          this.activeGameData.betResponse.gameContext.contextData.finished
        ) {
          if (
            this.rankingList.getVisible() == false &&
            this.rankingList.getMessagePopupVisible() == false
          ) {
            this.rankingList.onClick();
          }
        }
      }
    });

    // this.autoUpdateTicker.start();
    this.enableAutoUpdate(true);
  };
  public requestInfoSuccesRankUpdate = (): void => {
    this.ticker_D = Date.now();
    this.requestServer();
  };

  public enableAutoUpdate = (bool: boolean): void => {
    if (bool) {
      this.autoUpdateTicker.start();
    } else {
      this.autoUpdateTicker.stop();
    }
  };

  public requestServer = (): void => {
    //request
    //!always add to the game collect to update
    if (this.activeGameData.isTournament) {
      let pageData = {
        page: this.rankingList.getCurrentPage(),
        limit: this.rankingList.getMaxRankPerPage(),
      };
      // console.log(pageData);
      this.activeGameData.API_handler.GetTournamentRanking(
        pageData,
        this.serverRequestSuccess.bind(this),
        this.serverRequestFail.bind(this)
      );
    }
  };

  public requeServerForScore = (): void => {
    this.activeGameData.API_handler.GetTournamentScoreOnly(
      this.serverRequestScoreSuccess.bind(this),
      this.serverRequestFail.bind(this)
    );
  };

  public setTimeleft = (newVal: Date): void => {
    let localTime = newVal;
    let addZeroHours = "0";
    let addZeroMinutes = "0";
    if (localTime.getHours() > 9) {
      addZeroHours = "";
    }
    if (localTime.getMinutes() > 9) {
      addZeroMinutes = "";
    }
    let displayTime =
      localTime.toLocaleDateString("en-GB") +
      " " +
      addZeroHours +
      localTime.getHours() +
      ":" +
      addZeroMinutes +
      localTime.getMinutes();

    this.data_timeLeft = displayTime;
    this.display_timeLeft.text = this.data_timeLeft;
  };

  public setPortraitPosition = (): void => {
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    let screenRatio = window.innerHeight / window.innerWidth;

    if (
      this.activeGameData.playOnPortrait &&
      this.activeGameData.isMobile &&
      orientationPortrait &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      // console.log('V')
      let newScaleSmall = 2.05;

      this.ui_points.scale.set(newScaleSmall);
      this.ui_ranking.scale.set(newScaleSmall);
      this.ui_timeleft.scale.set(newScaleSmall);

      let cornerOffset = 10;
      this.ui_points.position.set(
        this.activeGameData.size[0] - this.ui_points.width / 2 - cornerOffset,
        -this.ui_points.height * 3.5
      );
      this.ui_ranking.position.set(
        this.ui_ranking.width / 2 + cornerOffset,
        this.ui_points.y
      );
      this.ui_timeleft.position.set(
        this.activeGameData.size[0] / 2,
        this.ui_points.y
      );
      this.setModeLandscape(false);

      let btnScale = 1.6;
      this.btn_redirectToHomepage.scale.set(btnScale * 0.85);
      this.btn_openCloseTournament.scale.set(btnScale);
      this.btn_redirectToHomepage.position.set(70 * 2, -260);
      //on portrait mode the button is on the right side of the screen
      this.btn_openCloseTournament.position.set(
        this.activeGameData.size[0] - 70 * 2,
        -260
      ); //.set(this.btn_redirectToHomepage.x+130*2,this.btn_redirectToHomepage.y);
      if (this.activeGameData.isTableGame) {
        this.btn_openCloseTournament.position.set(
          this.activeGameData.size[0] - 70 * 2,
          -180
        );
        this.btn_openCloseTournament.scale.set(1);
      }
    } else {
      this.btn_redirectToHomepage.scale.set(0.7);
      this.btn_openCloseTournament.scale.set(0.7);
      this.btn_redirectToHomepage.position.set(80, 60 + 150);
      this.btn_openCloseTournament.position.set(80, 60 + 150); //.set(this.btn_redirectToHomepage.x,this.btn_redirectToHomepage.y+150);
      if (this.activeGameData.isTableGame) {
        this.btn_openCloseTournament.position.set(50, 620); //.set(this.btn_redirectToHomepage.x,this.btn_redirectToHomepage.y+150);
      }

      this.setDefaultPosition();
      this.setModeLandscape(true);
    }
  };

  private setDefaultPosition = (): void => {
    // console.log('H')
    //mobile scale
    let mobileLS = 1.3;
    let offsetH = 20;
    this.ui_points.scale.set(mobileLS);
    this.ui_ranking.scale.set(mobileLS);
    this.ui_timeleft.scale.set(mobileLS);
    let gameWidth = this.activeGameData.size[0];

    if (this.displayTimer) {
      this.ui_timeleft.x = this.ui_timeleft.width / 2 + offsetH;
      this.ui_timeleft.y = this.ui_points.height / 2 + 10;
      this.ui_ranking.x = gameWidth / 2;
      this.ui_ranking.y = this.ui_timeleft.y;
      this.ui_points.x = gameWidth - this.ui_points.width / 2 - offsetH;
      this.ui_points.y = this.ui_timeleft.y;
    } else {
      this.ui_ranking.x = gameWidth / 2 - this.ui_ranking.width / 2 - offsetH;
      this.ui_ranking.y = this.ui_points.height / 2 + 10;
      this.ui_points.x = gameWidth / 2 + this.ui_points.width / 2;
      // console.log(this.ui_points.width, this.ui_points.x,this.ui_ranking.x)
      this.ui_points.y = this.ui_points.height / 2 + 10;
    }
  };

  private makeClickable = (bool: boolean): void => {
    // this.ui_ranking.interactive = bool;
    // this.ui_ranking.buttonMode = bool;
    // // /--
    // this.ui_points.interactive=bool;
    // this.ui_points.buttonMode=bool;

    this.btn_openCloseTournament.interactive = bool;
    this.btn_openCloseTournament.buttonMode = bool;

    this.btn_redirectToHomepage.interactive = bool;
    this.btn_redirectToHomepage.buttonMode = bool;

    if (this.activeGameData.isMobile) {
      if (this.activeGameData.isIphone) {
        //way bigger hitbox for iphone than desktop
        this.ui_ranking.hitArea = new PIXI.Rectangle(
          0,
          0,
          this.ui_ranking.width,
          this.ui_ranking.height + 70
        );
        this.ui_points.hitArea = new PIXI.Rectangle(
          0,
          0,
          this.ui_points.width,
          this.ui_points.height + 70
        );
      } else {
        // slightly bigger hitbox than deskop
        this.ui_ranking.hitArea = new PIXI.Rectangle(
          0,
          0,
          this.ui_ranking.width,
          this.ui_ranking.height + 55
        );
        this.ui_points.hitArea = new PIXI.Rectangle(
          0,
          0,
          this.ui_points.width,
          this.ui_points.height + 55
        );
      }
    }
  };
  public openPopup = (): void => {
    this.openRanking(); //open the poper and set the interactivity;
    // let pageData={"page":1,"limit":this.maxPerPage};
    // this.activeGameData.API_handler.GetTournamentRanking(pageData,this.serverRequestSuccess.bind(self),this.serverRequestFail.bind(self))
    this.requestServer();
  };
  private openRanking = (): void => {
    this.rankingList.onClick();
  };

  private goToRankingPage = (): void => {
    this.goToSelectedPage(1);
  };
  public goToSelectedPage = (pangeNum: number): void => {
    // return
    this.rankingList.openPopUpWindow(pangeNum);
    this.requestServer();
  };

  public serverRequestScoreSuccess = (data: TournamentParticipation): void => {
    // console.log(data)
    this.setPoints(data.score); //update player score on game

    this.activeGameData.tournamentScoreResponse = data;
    this.rankingList.setTournamentID(data.tournamentId);

    this.rankingList.setNewScore(data.score); //only score
    // this.rankingList.se
    this.checkEndTournament();
  };

  private checkEndTournament = (): void => {
    if (this.activeGameData.tournamentScoreResponse.state != "ACTIVE") {
      this.setEndScreen();
    }
  };

  public setEndScreen() {
    this.isActive = true;
    this.rankingList.setEndScreen(this.isActive);
    this.goToSelectedPage(3); //openRanking REGISTER page;
  }
  private serverRequestSuccess = (data: TournamentRanking): void => {
    if (this.activeGameData != undefined) {
      this.activeGameData.tournamentResponse = data;
    }
    this.rankingList.setRankingFromData(data); //all except score
    //update the ingame display
    let playerData = data.playerCurrentEntry;
    this.setRanking(playerData.position, data.totalNumberOfEntries);
  };
  private serverRequestFail = (): void => {
    //disable game and show error msg
    // this.a
    //return fake data
    // let list=[ {"position":1,"displayName":"Dd","score":1000,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":2,"displayName":"Diia","score":500,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":3,"displayName":"Dish","score":200,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":4,"displayName":"Desh","score":100,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":5,"displayName":"Diiph","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":6,"displayName":"Diiph","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":7,"displayName":"Diipe","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":8,"displayName":"Dish","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":9,"displayName":"ipesh","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":10,"displayName":"Desh","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":11,"displayName":"Dii","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":12,"displayName":"Desh","score":110,"prize":{"amount":5000,"currency":"EUR"}},];
    // let fakeData=
    // {"playerCurrentEntry":{"position":1,"displayName":"Diipesh","score":0,"prize":{"amount":5000,"currency":"EUR"}},
    // "playerTopEntry":{"position":1,"displayName":"Diipesh","score":0,"prize":{"amount":5000,"currency":"EUR"}},
    // "totalNumberOfEntries":12,
    // "entries":[list[this.rankingList.getCurrentPage()-1]
    // ],"page":this.rankingList.getCurrentPage(),"numberOfPages":12}
    // this.serverRequestSuccess(fakeData);
  };

  public closeRankingsPopup = (): void => {
    this.rankingList.close();
  };

  private setModeLandscape = (bool: boolean): void => {
    // console.log(bool)
    if (bool) {
      //landscape mode
      ///
      this.rankingList.setLandscapeMode();
      this.rankingContainer.y = 25;
      this.parent.y = 0;
    } //portrait mode
    else {
      this.rankingList.setPortraitMode();
      this.rankingContainer.y = -100;
      this.parent.y = 0;
    }
  };

  public getIsOpen = (): boolean => {
    return this.rankingList.getVisible();
  };

  // public setTopBtnVisible=(bool:boolean):void=>
  // {
  //     let nAlpha=bool?1:0;
  //     this.ui_timeleft.alpha=nAlpha;
  //     this.ui_points.alpha=nAlpha;
  //     this.ui_ranking.alpha=nAlpha;
  //     // this.ui_timeleft.scale.set(nAlpha);
  //     // this.ui_points.scale.set(nAlpha);
  //     // this.ui_ranking.scale.set(nAlpha);
  //     // console.log('BOOLEAN', bool)
  // }

  public onResize = (): void => {
    //define waht to do when ned to rescale

    // if(this.activeGameData.isMobile && this.activeGameData.isInPortraitMode){} //--no  more required since condition is checked before the call
    if (this.activeGameData.isInPortraitMode) {
      // console.log('Do STUFFS')
      this.rankingList.onResize();
    } else {
      this.rankingList.setDefaultSize();
      // console.log('Do NoTHIN')
    }
  };
  public getParent = (): PIXI.Container => {
    return this.parent;
  };
}
